import { render, staticRenderFns } from "./project_structure_new.vue?vue&type=template&id=0ce68a74&scoped=true"
import script from "./project_structure_new.vue?vue&type=script&lang=js"
export * from "./project_structure_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce68a74",
  null
  
)

export default component.exports